<template>
  <v-navigation-drawer v-model="showDrawer" :width="width" fixed temporary>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title class="text-h6">
          {{ titulo }}
        </v-list-item-title>
        <v-list-item-subtitle>
          {{ modulo }}
        </v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-action>
        <v-btn icon title="Fechar" @click="onCloseClick">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
      </v-list-item-action>      
    </v-list-item>

    <v-divider></v-divider>
    <div class="px-2">
      <slot></slot>
    </div>
  </v-navigation-drawer>
</template>

<script>
import Vue from "vue";

export default Vue.component("tj-nav-drawer", {
  model: {
    prop: "value",
    event: "update"
  },

  props: {
    titulo: String,
    modulo: String,
    value: Boolean,
    width: {
      type: [String, Number],
      default: 600
    }
  },

  data() {
    return {
      showDrawer: this.value
    };
  },

  watch: {
    showDrawer(v) {
      if (v !== this.value) this.$emit("update", v);
    },

    value(v) {
      this.showDrawer = v;
    }
  },

  methods: {
    onCloseClick(){
      this.showDrawer = false
    },


  }
});
</script>
